<template>
  <div
    v-if="workbench.sensitiveContentWarningVisible"
    class="sensitive-warning-mask"
    role="presentation"
    @click.self="workbench.closeSensitiveContentWarning"
  >
    <section
      class="sensitive-warning-dialog"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="sensitive-warning-title"
      aria-describedby="sensitive-warning-description"
    >
      <div class="sensitive-warning-icon" aria-hidden="true">!</div>
      <h2 id="sensitive-warning-title">内容安全警告</h2>
      <p id="sensitive-warning-description">
        检测到上传图片或生成请求可能包含色情、裸露或其他敏感内容，本次生成已被拦截。
        请更换合规图片并调整提示词后重试，请勿上传或生成违规内容。
      </p>
      <button type="button" autofocus @click="workbench.closeSensitiveContentWarning">我知道了</button>
    </section>
  </div>
</template>

<script setup>
import { useWorkbenchStore } from '@/stores/useWorkbenchStore'

const workbench = useWorkbenchStore()
</script>

<style scoped>
.sensitive-warning-mask {
  position: fixed;
  inset: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(15, 23, 42, 0.56);
  backdrop-filter: blur(3px);
}
.sensitive-warning-dialog {
  width: min(420px, 100%);
  padding: 28px 28px 24px;
  border: 1px solid rgba(220, 38, 38, 0.2);
  border-radius: 16px;
  background: var(--bg-white, #fff);
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.28);
  text-align: center;
  animation: sensitive-warning-in 0.2s ease-out;
}
.sensitive-warning-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  margin: 0 auto 14px;
  border-radius: 50%;
  background: #fef2f2;
  color: #dc2626;
  font-size: 30px;
  font-weight: 700;
}
.sensitive-warning-dialog h2 {
  margin: 0 0 10px;
  color: var(--text-title, #0f172a);
  font-size: 20px;
}
.sensitive-warning-dialog p {
  margin: 0;
  color: var(--text-body, #475569);
  font-size: 14px;
  line-height: 1.75;
}
.sensitive-warning-dialog button {
  min-width: 120px;
  margin-top: 22px;
  padding: 9px 22px;
  border: 0;
  border-radius: 8px;
  background: #dc2626;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}
.sensitive-warning-dialog button:hover { background: #b91c1c; }
.sensitive-warning-dialog button:focus-visible {
  outline: 3px solid rgba(220, 38, 38, 0.25);
  outline-offset: 2px;
}
@keyframes sensitive-warning-in {
  from { opacity: 0; transform: translateY(10px) scale(0.98); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}
</style>
